/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityProviderSettingsListItem,
    IdentityProviderSettingsListItemFromJSON,
    IdentityProviderSettingsListItemFromJSONTyped,
    IdentityProviderSettingsListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityProviderSettingsListItemPaginationWrapper
 */
export interface IdentityProviderSettingsListItemPaginationWrapper {
    /**
     * 
     * @type {Array<IdentityProviderSettingsListItem>}
     * @memberof IdentityProviderSettingsListItemPaginationWrapper
     */
    items?: Array<IdentityProviderSettingsListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityProviderSettingsListItemPaginationWrapper
     */
    totalItems?: number;
}

export function IdentityProviderSettingsListItemPaginationWrapperFromJSON(json: any): IdentityProviderSettingsListItemPaginationWrapper {
    return IdentityProviderSettingsListItemPaginationWrapperFromJSONTyped(json, false);
}

export function IdentityProviderSettingsListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(IdentityProviderSettingsListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function IdentityProviderSettingsListItemPaginationWrapperToJSON(value?: IdentityProviderSettingsListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(IdentityProviderSettingsListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


